import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import { usePackage } from "@/hooks/usePackage";

// Pobiera paczkę bezpośrednio z serwera. Gdy jej nie ma: link z ustawień, a w ostateczności strona /pobierz.
export default function DownloadButton({ settings, primary = false, label = "Pobierz grę", testId = "download-btn", showSize = false }) {
  const pkg = usePackage();
  const cls = `btn ${primary ? "btn-primary" : ""}`;
  const size = pkg?.available && showSize ? <span className="font-sans text-xs tracking-normal opacity-80">({pkg.size_text})</span> : null;

  if (pkg?.available) {
    return <a href={pkg.url} download={pkg.name} className={cls} data-testid={testId}><Download size={18} /> {label} {size}</a>;
  }
  if (pkg && settings?.download_url) {
    return <a href={settings.download_url} target="_blank" rel="noreferrer" className={cls} data-testid={testId}><Download size={18} /> {label}</a>;
  }
  return <Link to="/pobierz" className={cls} data-testid={testId}><Download size={18} /> {label}</Link>;
}
